<!--
 * @Author: your name
 * @Date: 2021-05-25 14:59:09
 * @LastEditTime: 2021-12-22 14:39:53
 * @LastEditors: fangshengchu
 * @Description: In User Settings Edit
 * @FilePath: \plantmate-shopping\src\views\modules\trainManagement\community\ExpertsQuestion.vue
-->
<template>
  <div class="ExpertsQuestion">
    <div class="k-tecdocument">
      <h2>专家问答</h2>
      <!-- 专家问答一级分类选择区域 -->
      <div class="k-doctypelisthead">
        <ul class="k-doctypelist">
          <li
            v-for="(item, index) in exportTypeList"
            :key="index"
            :class="index === currentExportIndex ? 'k-doctypelist-active' : ''"
            @click="changeExportIndex(index)"
          >
            {{ item.fieldName }}
          </li>
        </ul>
        <!-- 专家问答列表跳转 -->
        <div class="k-doctypelist-more" @click="goRouter">
          <span class="moreLink">
            更多
          </span>
          <div class="morePicture"></div>
        </div>
      </div>
      <!-- 专家问答主体 -->
      <el-row
        class="bacfff"
        :gutter="10"
        v-if="
          currentExportIndex !== -1 &&
          exportTypeList[currentExportIndex] &&
          exportTypeList[currentExportIndex].expertFieldRepliyVoList
        "
      >
        <el-col
          :span="12"
          class="margin10"
          v-for="(item, index) in exportTypeList[
            currentExportIndex
          ].expertFieldRepliyVoList.slice(0, 4)"
          :key="index"
        >
          <el-col class="bacf8">
            <el-col :span="6">
              <!--  style="text-align:center;" -->
              <div></div>
              <div class="tpic" @click.stop="routerHandleExportDetail(item)">
                <img
                  :alt="item.name"
                  :src="item.userAvatarUrl || defaultImg"
                  width="70px"
                  height="70px"
                  style="border-radius: 30px; cursor: pointer"
                  class="fit-cover"
                />
              </div>
              <div
                class="ask"
                @click="routerHandleAskExport(item.id, item.name)"
              >
                我要提问
              </div>
            </el-col>
            <el-col :span="18" class="askbox">
              <h4>{{ item.name }}&nbsp;专家</h4>
              <div v-if="item.fileVideoTypeAttributeEntityList" class="overell">

                <span
                  v-for="(
                    itemLabel, indexLabel
                  ) in item.fileVideoTypeAttributeEntityList"
                  :key="indexLabel"
                >
                  {{ itemLabel.typeAttributeValue }}
                </span>
              </div>
              <div :title="item.expertIntroduction" class="askbox-introduction">
                {{ item.expertIntroduction }}
              </div>
            </el-col>
          </el-col>
        </el-col>
        <el-col>
          <div @click="routerHandleAskExport()">
            <el-col :span="4" :offset="10" class="askbut">我要提问</el-col>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  expertDetail,
  expertPutQuestionsTo
  //   knowledgeStayTime
} from '@/utils/eventTracking'

export default {
  data () {
    return {
      defaultImg: require('@/assets/img/defaultPeopleImg.png'),
      currentExportIndex: -1,
      exportTypeList: [] // 专家问答列表
    }
  },

  methods: {
    // 获取一级专家类别及其下对应的专家
    getExportMenuList () {
      this.currentExportIndex = -1
      this.$http
        .get(
          `${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldtype/selectHeadAndTails`
        )
        .then(({ data }) => {
          let exportTypeList = data.data || []
          // let all = []
          // let allhotToppic = []
          // exportTypeList.forEach(element => {
          //   if (element.expertFieldRepliyVoList && element.expertFieldRepliyVoList.length) {
          //     all.push(...element.expertFieldRepliyVoList)
          //   }
          //   if (element.expertUserArticleVos && element.expertUserArticleVos.length) {
          //     allhotToppic.push(...element.expertUserArticleVos)
          //   }
          // })
          // if (all.length) {
          //   exportTypeList.unshift({
          //     fieldName: '全部',
          //     expertFieldRepliyVoList: all,
          //     expertUserArticleVos: allhotToppic
          //   })
          //   this.currentExportIndex = 0
          // }
          if (exportTypeList.length) {
            this.currentExportIndex = 0
          } else {
            this.currentExportIndex = -1
          }
          this.exportTypeList = exportTypeList.splice(0, 7)
        })
    },
    // 切换专家当前分类
    changeExportIndex (index) {
      let temp = this.exportTypeList[index]
      if (
        !temp.expertFieldRepliyVoList ||
        !temp.expertFieldRepliyVoList.length
      ) {
        this.$message.warning('暂时没有内容,请浏览其他内容')
      } else {
        this.currentExportIndex = index
      }
    },
    // 3向专家提问
    routerHandleAskExport (id, name) {
      if (id) {
        expertPutQuestionsTo(name)
        this.$router.push({
          name: 'askToExpert',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({ name: 'chooseExpert' })
      }
    },
    // 跳转到专家详细页面
    routerHandleExportDetail (item) {
      expertDetail(item.name)
      this.$router.push({
        name: 'exportDetail',
        query: {
          id: item.id,
          uId: item.userId
        }
      })
    },
    goRouter () {
      this.$router.push('/expertIndex')
    }
  },

  created () {
    this.getExportMenuList()
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}
.ExpertsQuestion {
  width: 1190px;
  margin: 0 auto;
}
.upload-cancel {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  box-sizing: border-box;
  border: 1px solid #1d65a8;
  color: #1d65a8;
  font-size: 14px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.upload-cancel:hover {
  opacity: 0.8;
}
.doc-upload {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.doc-upload-area h3 {
  height: 30px;
  font-size: 20px;
  margin: 10px 0;
  color: #333333;
}
.uploadPickUp {
  width: 106px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #595959;
  border: 1px solid #dddddd;
  border-radius: 4px;
}
.uploadPickUp .el-icon-upload2 {
  color: #595959;
  font-size: 14px;
}
.doc-upload-area input {
  width: 92%;
  margin: 0 auto;
  line-height: 24px;
  font-size: 18px;
  display: block;
  border: 1px solid #cccccc;
  padding: 4px 10px;
  border-radius: 6px;
}
.doc-upload-area input:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-typechoose ul {
  padding-left: 80px;
}
.doc-upload-kindonechoose ul {
  margin-top: -30px;
}
.doc-upload-kindonechoose ul li {
  list-style: none;
}
.doc-upload-area textarea {
  width: 92%;
  height: 80px;
  line-height: 20px;
  resize: none;
  font-size: 16px;
  margin: 0 auto 20px auto;
  display: block;
  padding: 4px 10px;
  border: 1px solid #cccccc;
  border-radius: 6px;
}
.doc-upload-area textarea:focus {
  border: 1px solid #1d65a8;
}
.doc-upload-area .el-upload__tip {
  word-break: break-all;
}
.doc-upload-fileorvedio {
  display: flex;
  margin-bottom: 20px;
}
.doc-upload-fileorvedio div {
  padding: 2px 10px;
  text-align: center;
  margin: 0 10px;
  border: 1px solid #1d65a8;
  user-select: none;
  cursor: pointer;
}
.uploadFileTypeOneActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindonechoose {
  margin-bottom: 20px;
}
.doc-upload-kindonechoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindonechoose ul li {
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
.uploadFileTypeTwoActive {
  background: #1d65a8;
  color: #ffffff;
}
.uploadFileTypeThreeActive {
  background: #1d65a8;
  color: #ffffff;
}
.doc-upload-kindtwochoose {
  margin-bottom: 20px;
}
.doc-upload-kindtwochoose ul {
  display: flex;
  flex-wrap: wrap;
}
.doc-upload-kindtwochoose ul li {
  list-style: none;
  padding: 0 8px;
  border: 1px solid #1d65a8;
  margin-right: 10px;
  user-select: none;
  cursor: pointer;
  margin-top: 10px;
}
/* 顶部轮播图 */
.k-banner {
  height: 400px;
  margin-bottom: 30px;
}
.el-carousel__arrow {
  display: none;
}
.el-carousel {
  height: 400px;
}
.el-carousel__container {
  height: 400px;
}
.el-carousel__item {
  height: 400px;
}
.el-carousel__item img {
  cursor: pointer;
  height: 400px;
  width: 1190px;
  display: block;
}

/* 功能（搜索以及上传）区域 */
.k-function {
  display: flex;
  padding: 0 45px;
  margin-bottom: 30px;
}
.k-f-ask {
  user-select: none;
  cursor: pointer;
}
.k-f-ask:hover {
  background: #174773;
}
.k-f-s {
  display: inline-block;
  width: 46px;
  height: 46px;
  margin-left: -46px;
  cursor: pointer;
  z-index: 100;
}
.k-search {
  padding: 0 20px;
  width: 750px;
  height: 46px;
  border: none;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
}
.k-search::-webkit-input-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-search:-moz-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-search:-ms-input-placeholder {
  color: #bebebe;
  font-size: 14px;
}
.k-function button {
  border: none;
  background: #1d65a8;
  width: 150px;
  height: 46px;
  color: #ffffff;
  font-size: 16px;
  line-height: 46px;
  margin-left: 20px;
}

/* 技术文档区域 */
.k-tecdocument h2 {
  font-size: 26px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 10px;
  margin-top: 20px;
}
.k-doctypelisthead {
  display: flex;
  position: relative;
}
.k-doctypelist-more {
  position: absolute;
  right: 0;
  padding-left: 8px;
  padding-right: 5px;
  font-size: 14px;
  color: #262626;
  display: flex;
  line-height: 32px;
  user-select: none;
  cursor: pointer;
}
.k-doctypelist-more:hover span {
  color: #ffffff;
}
.morePicture {
  width: 10px;
  height: 11px;
  display: block;
  margin-top: 10px;
  margin-left: 6px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAVCAYAAACQcBTNAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6ODZEN0MyOEM5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6ODZEN0MyOEQ5RDQ4MTFFOUFGMzZEQzFDMkQyQTM4OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4NkQ3QzI4QTlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4NkQ3QzI4QjlENDgxMUU5QUYzNkRDMUMyRDJBMzg5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PrUEepsAAADHSURBVHjajJHBCYUwDEBTwRE8CJ4LevXqAg7gCg7QHeoUjuHBEbxJ7x2jIKWHfOpB8NumDaRN4L3SEDZNE9Z1DcuysLIsgYrCg/u+gxACnXMkDMYYmOcZOefob99ba4N5H7nCU+QIryYlfGxKCP4tJkQnDwlR+F+QUmJB7cBvdBzHu9Za0y9v24Zt22Lf96iUwizwPE+MDhgCg3AM/MAU+IJT4APngDecC/pkwzDgdV2writ0XceoJbHjOLCqKmiahkEifgIMACjN8xlwRNSeAAAAAElFTkSuQmCC)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-more:hover .morePicture {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAVCAYAAAByrA+0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QTNGRUVFQjFDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QTNGRUVFQjJDOTQ0MTFFOUJDMkVDMEU2RjJDMzA5MTciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpBM0ZFRUVBRkM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpBM0ZFRUVCMEM5NDQxMUU5QkMyRUMwRTZGMkMzMDkxNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Puq9PDkAAABxSURBVHjalJNJDsAwCAPB//8zbaUeXArBcMgmD4FE9oiwO57BTQi8YqN5BDhzKIBtINBagpD2I4Ti7AihubmFcOivhDC84g+C8FcfSAG4B8dGPJUUVVnYiDugFVfAUZyBUcyAJM6OM8Wm7DjJ05cAAwA/gRgnP8oHOgAAAABJRU5ErkJggg==)
    no-repeat;
  background-size: 6px 11px;
}
.k-doctypelist-more:hover .moreLink {
  color: white !important;
}
.k-doctypelist {
  display: flex;
  flex-wrap: wrap;
  width: 1100px;
  height: 32px;
  overflow: hidden;
  margin-bottom: 19px;
}
.k-doctypelist li {
  list-style: none;
  height: 32px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  padding: 0 10px;
}
.k-doctypelist li:hover {
  background: #1d65a8;
  color: white;
}
.k-doctypelist-active {
  background: #1d65a8;
  color: #ffffff;
}
.k-doclist {
  display: flex;
  flex-wrap: wrap;
  /* border: 1px solid #cccccc; */
}
.k-doclist li {
  list-style: none;
  width: 396px;
  height: 220px;
  box-sizing: border-box;
  position: relative;
  padding: 20px 27px 33px 31px;
  user-select: none;
  cursor: pointer;
}
.k-doclistv-view {
  border: 1px #f9f9f9 solid;
  /* border-bottom: 1px #eeeeee solid;
  border-top: 1px #fff solid;
  border-right: 1px #fff solid; */
  background: #fff;
}
.k-doclistv-view p{
  margin-top: 0;
}
.k-doclistv-view:hover {
  border: 1px solid #1d65a8;
  padding: 20px 27px 33px 31px;
}
.k-doclistv-view:hover .k-doctype {
  /* margin: -2px 0 0 -2px; */
}
.k-doctype {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0;
  left: 0;
}
.k-doclist li h3 {
  font-size: 16px;
  line-height: 45px;
}
.k-doclist li p {
  line-height: 21px;
  font-size: 13px;
  color: #999999;
  margin-bottom: 14px;
  height: 42px;
  overflow: hidden;
}
.k-docauthor {
  display: flex;
  line-height: 30px;
  position: relative;
  margin-bottom: 24px;
}
.k-docauthor-icon {
  width: 29px;
  height: 30px;
  border-radius: 50%;
}
.k-docauthor-name {
  margin-left: 10px;
  font-size: 13px;
  color: #696969;
}
.k-docauthor-date {
  position: absolute;
  right: 8px;
}
.k-docview {
  display: flex;
  position: relative;
}
.k-docview-use {
  display: flex;
  position: absolute;
  right: 8px;
}
.k-docview-likeicon {
  width: 14px;
  height: 13px;
  display: block;
  margin-top: 4px;
}
.k-docview-collect {
  color: #1d65a8;
  margin-right: 32px;
  padding-left: 4px;
}
.k-docview-downloadicon {
  width: 15px;
  height: 15px;
  display: block;
  margin-top: 2px;
}
.k-docview-download {
  color: #1d65a8;
  padding-left: 4px;
}
.k-f-upload {
  user-select: none;
  cursor: pointer;
}
.k-f-upload:hover {
  background: #174773;
}
/* 技术视频 */
.k-video {
  margin-top: 20px;
}
.k-video h2 {
  font-size: 26px;
  font-weight: 500;
  color: #262626;
  margin-bottom: 10px;
}
.k-videoTypeList-head {
  display: flex;
  position: relative;
}
.k-videoTypeList {
  display: flex;
  flex-wrap: wrap;
  width: 1100px;
  height: 32px;
  overflow: hidden;
  margin-bottom: 19px;
}
.k-videoTypeList li {
  list-style: none;
  height: 32px;
  line-height: 32px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  padding: 0 10px;
}
.k-videoTypeList li:hover {
  background: #1d65a8;
  color: white;
}
.k-video-list {
  display: flex;
  margin-bottom: 30px;
}
.k-video-perfect {
  width: 316px;
  height: 522px;
  position: relative;
}
.k-video-right {
  width: 875px;
  display: flex;
  flex-wrap: wrap;
  padding-left: 40px;
  padding-top: 30px;
  padding-right: 9px;
  background: #ffffff;
}
.k-video-right li {
  list-style: none;
  width: 255px;
  margin-right: 20px;
  height: 218px;
  position: relative;
  user-select: none;
  cursor: pointer;
}
.k-video-right li h3 {
  font-size: 16px;
  color: #333333;
  line-height: 36px;
}
.k-video-play {
  width: 38.7px;
  height: 38.7px;
  position: absolute;
  top: 60px;
  left: 108px;
}
.k-video-adv {
  width: 316px;
  height: 522px;
}
.k-video-collect {
  display: flex;
}
.k-video-text {
  display: flex;
  line-height: 26px;
}
.k-video-text p {
  flex: 1;
  font-size: 12px;
  color: #666666;
}
/* 专家问答 */
.tpic {
  border-radius: 50px;
  height: 70px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 10px;
  /* margin: 20px 10px 10px 10px; */
  width: 70px;
  overflow: hidden;
}
.ask {
  width: 80px;
  margin: 0 auto;
  border: 1px #1d65a8 solid;
  text-align: center;
  line-height: 35px;
  color: #1d65a8;
  margin-bottom: 20px;
}
.ask:hover {
  background: #1d65a8;
  color: #ffffff;
  cursor: pointer;
}
.bacf8 {
  background: #f8f8f8;
}
.bacfff {
  background: #ffffff;
  height: auto;
  margin-top: 0px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.margin10 {
  margin: 10px 0px;
}
.askbox {
  margin-top: 15px;
  text-align: left;
  max-height: 142px;
}
.askbox h4 {
  line-height: 30px;
}
.askbox span {
  line-height: 20px;
  margin-bottom: 20px;
  height: 45px;
}
.askbox-introduction {
  height: 54px;
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 100%;
  color: #999;
  word-wrap: break-word;
  word-break: break-all;
}
.askbut {
  background: #1d65a8;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  margin-top: 10px;
  margin-bottom: 20px;
}
.askbut:hover {
  background: #2b7dca;
  cursor: pointer;
}
/* 热门话题 */
.hotTopic {
  background-color: #fff;
  padding: 30px;
  word-wrap: break-word;
  word-break: break-all;
}
.hotTopic-title {
  padding-bottom: 20px;
}
.hotTopic-tpic {
  width: 70px;
  height: 70px;
  border-radius: 35px;
  /* border: #262626 1px solid; */
  overflow: hidden;
}
.hotTopic-content {
  width: 100%;
  position: relative;
}
.hotTopic-content-icon {
  margin-right: 6px;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  /* background: #1D65A8; */
  color: #fff;
}
.hotTopic-content-main {
  position: absolute;
  top: 0;
  left: 30px;
  display: inline-block;
  width: 100%;
}
.hotTopic-content-replay {
  height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  margin-bottom: 10px;
  color: #999;
}
.hotTopic-content-endDate {
  text-align: right;
}
.overell {
  margin: 0;
  /* color: #999; */
}
ul {
  padding-left: 0;
}
p {
  margin: 0;
}
</style>
